import React, { useState } from 'react';
import Logo from '../../assets/img/logo-successT.png';
import { Box, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import { useStudentAuth } from '../../context/StudentAuthContext';
import { useAdminAuth } from '../../context/AdminAuthContext';
import LogoutButton from './LogoutButton';

function Header() {
  const { student, studentLogout, isAuthenticated: isStudentAuthenticated } = useStudentAuth();
    
  const { admin, adminLogout, isAuthenticated: isAdminAuthenticated } = useAdminAuth();
  
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [logoutError, setLogoutError] = useState(null);

  const navigateHome = () => {
    navigate('/home');
  };

  const userRegisterBtn = () => {
    navigate('/students-registration');
  };

  // const handleStudentLogout = async () => {
  //   if (window.confirm("Are you sure you want to logout?")) {
  //     try {
  //       setIsLoggingOut(true);
  //       setLogoutError(null);
  //       await studentLogout();
  //     } catch (error) {
  //       console.error("Logout Failed", error);
  //       setLogoutError(error.message);
  //       // Force redirect even if logout fails
  //       // window.location.href = '/students-login';
  //     } finally {
  //       setIsLoggingOut(false);
  //     }
  //   }
  // };
const handleLogoutStart = () => {
        console.log('Starting logout...');
        // Optional: Show loading state in header
    };

    const handleLogoutComplete = () => {
        console.log('Logout complete');
        // Optional: Update header state
    };
  const handleAdminLogout = async () => {
    if (window.confirm("Are you sure you want to logout?")) {
      try {
        setIsLoggingOut(true);
        await adminLogout();
      } catch (error) {
        console.error("Admin Logout Failed", error);
        // window.location.href = '/admin-login';
      } finally {
        setIsLoggingOut(false);
      }
    }
  };

  return (
    <div className='top-header'>
      <Container maxWidth="lg" className="parentdiv">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container sx={{ alignItems: "center" }}>
            <Grid item sx={{ width: '100', height: '100' }}>
              <div className='logo'>
                <a onClick={navigateHome} style={{ cursor: 'pointer' }}>
                  <img src={Logo} alt='Success Tutorial' style={{ maxWidth: '100%', height: 'auto' }} />
                </a>
              </div>
            </Grid>
            <Grid item sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexGrow: 1 }}>
              <h1 className='ml-20'>Success Tutorial</h1>
            </Grid>
            <Grid item md={5} xs={5} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              {isStudentAuthenticated ? (
                <>
                  <div className="welcome-text">
                    Welcome, {student?.fullname || 'Student'}!
                  </div>
                  {/* <button
                    className='btn-default'
                    onClick={handleStudentLogout}
                    disabled={isLoggingOut}
                  >
                    {isLoggingOut ? 'Logging out...' : 'Logout'}
                  </button> */}
                  <div className="logout-container">
                            <LogoutButton
                                variant="button"
                                className="btn-default"
                                // onLogoutStart={handleLogoutStart}
                                // onLogoutComplete={handleLogoutComplete}
                                showConfirm={true}
                            >
                                Logout
                            </LogoutButton></div>
                  {logoutError && (
                    <div className="logout-error">
                      {logoutError}
                    </div>
                  )}
                </>
              ) : isAdminAuthenticated ? (
                <>
                  <div className="welcome-text">
                    Welcome, {admin?.name || 'Admin'}!
                  </div>
                  <button
                    className='btn-default'
                    onClick={handleAdminLogout}
                    disabled={isLoggingOut}
                  >
                    {isLoggingOut ? 'Logging out...' : 'Logout'}
                  </button>
                </>
              ) : (
                <button onClick={userRegisterBtn} className='btn-default'>
                  Enroll Now
                </button>
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}

export default Header;






// import React, { useState } from 'react';
// import Logo from '../../assets/img/logo-successT.png';
// import { Box, Container } from '@mui/material';
// import Grid from '@mui/material/Grid';
// import { useNavigate } from "react-router-dom";
// import { useAuth } from '../../context/StudentAuthContext';
// import { useAdminAuth } from '../../context/AdminAuthContext'

// function Header() {
//    const {logout, Authenticated, user} = useAuth()
//    const { admin, adminLogout, isAuthenticated} = useAdminAuth()
  
//   const navigate = useNavigate();
//   const [isLoggInout, setIsLogginOut] = useState(false);


//   const navigateHome = ()=>{
//     navigate('/home');
//   }
//   const userRegisterBtn = () => {
//     // console.log("Click Register");    
//     navigate('/students-registration');
//  }
//  const handleAdminLogout = async ()=>{
//   // console.log("Click");
  
//     if(window.confirm("Are you sure you want to logout?'")){
//       try {
//         setIsLogginOut(true)
//         await adminLogout()
//       } catch (error) {
//         console.error("Logout Failed", error)
//       }finally{
//         setIsLogginOut(false)
//       }
//     }
//  }
//     return(
//         <div className='top-header'>
//             <Container maxWidth="lg" className="parentdiv">
//   <Box sx={{ flexGrow: 1 }}>
//     <Grid container sx={{ alignItems: "center" }}> {/* Removed flexDirection */}
//       <Grid item sx={{with:'100', height:'100'}} >
      
//         <div className='logo'>
//           <a onClick={navigateHome}>
//             <img src={Logo} alt='' style={{ maxWidth: '100%', height: 'auto' }} /> {/* Responsive image */}
//           </a>
//         </div>
//       </Grid>
//       <Grid  item sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center',flexGrow: 1 }}> {/* Added item, centered content */}
//         <h1 className='ml-20'>Success Tutorial</h1>
//       </Grid>
//       <Grid item md={5} xs={5} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
//         {user ? (
//           <><div className="welcome-text">
//           Welcome, {user.fullname}!
//       </div><button 
//                     className='btn-default'
//                     onClick={logout}
//                 >
//                     Logout
//                 </button></>)
//                 : isAuthenticated ? (
//           <><div className="welcome-text">
//           Welcome, {admin.name}!
//       </div><button 
//                     className='btn-default'
//                     // disabled="authLoading"
//                     onClick={handleAdminLogout}
//                 >
//                     Logout
//                 </button></>)
//                 :(<button onClick={userRegisterBtn} className='btn-default'>Enroll Now</button>)
//                 } 
        
//       </Grid>
//     </Grid>
//   </Box>
// </Container>
//         </div>
//     )
// }

// export default Header 
